import React, { useState } from 'react';
import { BatchDocumentsTable } from './BatchDocumentsTable/BatchDocumentsTable';
export const BatchDocuments = ({ closeCheck }) => {

    return (
        <div>
            <BatchDocumentsTable closeCheck={closeCheck} />
        </div>
    );
};
